import { arrayOf, shape } from "prop-types";
import { useMemo } from "react";

import jsonParse from "web/utils/data/parser/string/jsonParse";
import isArrayHasItems from "web/utils/data/validator/array/isArrayHasItems";

import Products from "./products";

const SuccessProductsContainer = ({ items }) => {
  const itemsGroupedById = useMemo(() => {
    return isArrayHasItems(items)
      ? items.reduce((result, current) => {
          const {
            base_row_total: baseRowTotal,
            base_row_total_incl_tax: baseRowTotalInclTax,
            discount_amount: discountAmount,
            row_total: rowTotal,
            row_total_incl_tax: rowTotalInclTax,
            points_bank: pointsBank,
            qty_ordered: qty,
            payment_method: paymentMethod,
            ...restValues
          } = current;

          const pointsBankParsed = isArrayHasItems(jsonParse(pointsBank))
            ? jsonParse(pointsBank)
            : [];
          const itemIndexById = result.findIndex(
            (item) => current.product_id === item.product_id
          );
          /* eslint-disable no-param-reassign */
          if (itemIndexById !== -1) {
            result[itemIndexById] = {
              ...result[itemIndexById],
              base_row_total:
                baseRowTotal + result[itemIndexById].base_row_total,
              base_row_total_incl_tax:
                baseRowTotalInclTax +
                result[itemIndexById].base_row_total_incl_tax,
              discount_amount:
                discountAmount + result[itemIndexById].discount_amount,
              row_total: rowTotal + result[itemIndexById].row_total,
              row_total_incl_tax:
                rowTotalInclTax + result[itemIndexById].row_total_incl_tax,
              qty: qty + result[itemIndexById].qty,
              points_bank: result[itemIndexById].points_bank.map((bank) => {
                const bankById = pointsBankParsed.find(
                  ({ id }) => id === bank.id
                );

                return bankById
                  ? {
                      id: bank.id,
                      balance: bank.balance + bankById.balance,
                    }
                  : bank;
              }),
              payment_method: result[itemIndexById].payment_method.map(
                (paymentItem, paymentItemIndex) => {
                  // eslint-disable-next-line array-callback-return
                  paymentItem.values.map((paymentMethodType) => {
                    const currentPaymentValue =
                      paymentMethod[paymentItemIndex].values;
                    const sameNameValue = currentPaymentValue.find(
                      (currentValue) =>
                        currentValue.name === paymentMethodType.name
                    );
                    sameNameValue.value =
                      +sameNameValue.value +
                      (sameNameValue ? +paymentMethodType.value : 0);
                  });
                  return paymentMethod;
                }
              )[0],
            };
            return result;
          }

          return [
            ...result,
            {
              base_row_total: baseRowTotal,
              base_row_total_incl_tax: baseRowTotalInclTax,
              discount_amount: discountAmount,
              row_total: rowTotal,
              row_total_incl_tax: rowTotalInclTax,
              points_bank: pointsBankParsed,
              qty,
              payment_method: paymentMethod,
              ...restValues,
            },
          ];
        }, [])
      : [];
  }, [JSON.stringify(items)]);

  return isArrayHasItems(itemsGroupedById) ? (
    <Products items={itemsGroupedById} />
  ) : null;
};

SuccessProductsContainer.propTypes = {
  items: arrayOf(shape({})).isRequired,
};

export default SuccessProductsContainer;
